import * as util from '#packages/util';

const MAX_TEXT_SIZE = 50;

export function extractValuableText(rawText: string): string {
  let parsedText = rawText || '';

  parsedText = util.stringUtils.removeHtmlTagsFromString(parsedText); //Clear all HTML tags
  parsedText = util.stringUtils.removeBreakLinesFromString(parsedText); //Remove /n and /r
  parsedText = parsedText.substring(0, MAX_TEXT_SIZE); //Cut to reasonable length
  parsedText = htmlDecode(parsedText);

  return parsedText;
}

function htmlDecode(text: string) {
  const e = window.document.createElement('div');
  e.innerHTML = text;
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
}
